// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".course_description[data-v-314d3e2b]{list-style:none;margin-left:0;padding-left:0}.course_description li[data-v-314d3e2b]{line-height:3em;margin-left:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
